export const i18nContentHash = 'a2d23ba'
